// extracted by mini-css-extract-plugin
module.exports = {"paginatedBody":"Paginated_paginatedBody__1LCG4","pagination":"Paginated_pagination__1c2lQ"};